// WebAuthn helpers — convert between base64url (Resend/WebAuthn) and ArrayBuffer.
export function b64urlToBuffer(b64url) {
  const pad = "=".repeat((4 - (b64url.length % 4)) % 4);
  const b64 = (b64url + pad).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b64);
  const buf = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) buf[i] = raw.charCodeAt(i);
  return buf.buffer;
}

export function bufferToB64url(buf) {
  const bytes = new Uint8Array(buf);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

// Convert server options → PublicKeyCredentialCreationOptions
export function decodeCreationOptions(opts) {
  return {
    ...opts,
    challenge: b64urlToBuffer(opts.challenge),
    user: { ...opts.user, id: b64urlToBuffer(opts.user.id) },
    excludeCredentials: (opts.excludeCredentials || []).map(c => ({ ...c, id: b64urlToBuffer(c.id) })),
  };
}

// Encode credential returned by navigator.credentials.create() for the server
export function encodeAttestation(cred) {
  return {
    id: cred.id,
    rawId: bufferToB64url(cred.rawId),
    type: cred.type,
    response: {
      attestationObject: bufferToB64url(cred.response.attestationObject),
      clientDataJSON: bufferToB64url(cred.response.clientDataJSON),
    },
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
  };
}

// Convert server options → PublicKeyCredentialRequestOptions
export function decodeRequestOptions(opts) {
  return {
    ...opts,
    challenge: b64urlToBuffer(opts.challenge),
    allowCredentials: (opts.allowCredentials || []).map(c => ({ ...c, id: b64urlToBuffer(c.id) })),
  };
}

// Encode assertion returned by navigator.credentials.get() for the server
export function encodeAssertion(cred) {
  return {
    id: cred.id,
    rawId: bufferToB64url(cred.rawId),
    type: cred.type,
    response: {
      authenticatorData: bufferToB64url(cred.response.authenticatorData),
      clientDataJSON: bufferToB64url(cred.response.clientDataJSON),
      signature: bufferToB64url(cred.response.signature),
      userHandle: cred.response.userHandle ? bufferToB64url(cred.response.userHandle) : null,
    },
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
  };
}

export const isWebAuthnSupported = () => typeof window !== "undefined"
  && typeof window.PublicKeyCredential !== "undefined"
  && typeof navigator?.credentials?.create === "function";

// Local device storage
export const LS_KEYS = {
  pin_device: "nb_pin_device_id",
  webauthn_device: "nb_webauthn_device_id",
  last_user_email: "nb_last_email",
  last_user_name: "nb_last_name",
};

export function getStoredQuickLogin() {
  return {
    pin_device_id: localStorage.getItem(LS_KEYS.pin_device),
    webauthn_device_id: localStorage.getItem(LS_KEYS.webauthn_device),
    email: localStorage.getItem(LS_KEYS.last_user_email),
    name: localStorage.getItem(LS_KEYS.last_user_name),
  };
}

export function rememberUser(email, name) {
  if (email) localStorage.setItem(LS_KEYS.last_user_email, email);
  if (name) localStorage.setItem(LS_KEYS.last_user_name, name);
}

export function forgetQuickLogin(kind) {
  if (!kind || kind === "pin") localStorage.removeItem(LS_KEYS.pin_device);
  if (!kind || kind === "webauthn") localStorage.removeItem(LS_KEYS.webauthn_device);
  if (!kind) {
    localStorage.removeItem(LS_KEYS.last_user_email);
    localStorage.removeItem(LS_KEYS.last_user_name);
  }
}
